// extracted by mini-css-extract-plugin
module.exports = {"mobileAndTabletErrorMessageHolder":"MobileAndTabletErrorPage_mobileAndTabletErrorMessageHolder__2uSpx","errorLogo":"MobileAndTabletErrorPage_errorLogo__1H5XO"};